import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { PageResponse } from '@core/entities/pagination'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  IInspectionTemplateOverview,
  InspectionTemplateOverview,
} from '@core/entities/inspection/InspectionTemplateOverview'
import { inspectionTemplatesKeys } from '../inspectionTemplatesKeys'
import { RequestTypes } from '../requestTypes'

const dataTransformer = (
  response: PageResponse<IInspectionTemplateOverview>,
) => {
  return {
    ...response,
    content: response.content.map((inspectionTemplate) =>
      InspectionTemplateOverview.new(inspectionTemplate),
    ),
  }
}

export const useGetInspectionTemplates = (
  payload: RequestTypes['getInspectionTemplates'],
  options: UseQueryOptions<
    PageResponse<IInspectionTemplateOverview>,
    RequestErrorType,
    PageResponse<InspectionTemplateOverview>
  > = {},
) => {
  return useQuery({
    select: dataTransformer,
    ...inspectionTemplatesKeys.list(payload),
    keepPreviousData: true,
    enabled: !!payload.projectId,
    ...options,
  })
}
